<template>

  <!--    Registrierungs Frrumalr-->


  <div class="page">

    <!--<div class="absBack"> -->
    <!--           <div onclick="window.history.back()"> -->
    <!--                <v-icon medium dark>mdi-arrow-left</v-icon> -->
    <!--            </div> -->
    <!--        </div> -->


    <v-container>
      <h2 class="myTitle hidden-sm-and-down text-left" style="margin-bottom: 0;">Registrierung</h2>

      <div class="spacer-15 hidden-md-and-up"></div>
      <!--            <div>Registrieren Sie sich jetzt, um Ihren Coupon für <b>10% Rabatt</b> freizuschalten.-->
      <!--                Für die Benutzung von Coupons ist kein Internet notwendig.-->
      <!--                Als registrieter Nutzer können Sie die Coupons in allen teilnehmenden Filialen und im Online-Shop einlösen.-->
      <!--            </div>-->
      <!--        <h3 class="text-center"></h3>-->

      <v-form ref="form" v-model="valid" lazy-validation class="registerForm bigger-input">
        <!--            <form @submit.prevent="doRegister" class="registerForm bigger-input" onkeypress="return keyHandler(event);">-->


        <div class="indented" style="padding-top: 0;">
          <h3>Wie können wir Dich erreichen?</h3>
          <!--                    <div>DEBUG errors: {{displayErrors}}</div>-->
          <!--                Hinweis: Es ist nicht notwendig E-Mail zu bestätigen-->
          <!--                <h2>Wie können  {{$store.getters.storeName}} dich erreichen?</h2>-->
          <!--                <h2>Wie können  {{$store.getters.storeName}} dich erreichen?</h2>-->
          <v-text-field
            v-model="formData.name"
            :rules="nameRules"
            label="Vor- und Nachname *"
            placeholder="Vorname Nachname"
            hide-details illed
            required
            @focus="hideToolbar"
            @blur="unhideToolbar"
          ></v-text-field>
          <v-text-field
            v-model="formData.email"
            type="email"
            :rules="emailRules"
            label="E-Mail* (Bestelleingangsbestätigung)"
            placeholder="Für eine Kopie deiner Bestellung"
            hide-details illed
            required
            @focus="hideToolbar"
            @blur="unhideToolbar"
          ></v-text-field>
          <v-text-field
            ref="phone"
            @keydown="phoneKeydown($event)"
            v-model="formData.phone"
            :rules="phoneRules"
            label="Mobilnummer*"
            placeholder=""
            illed
            required
          ></v-text-field>
          <p>Hinweis: Du erhälst keine Werbe-Anrufe!</p>
        </div>

        <div class="indented">
          <h3>Rechnungsadresse</h3>
          <v-text-field
            v-model="formData.name"
            label="Vor- und Nachname"
            hide-details illed
            v-if="formData.invoiceAddress.company.length === 0"
          ></v-text-field>
          <v-text-field
            v-model="formData.invoiceAddress.company"
            label="Firma (optional)"
            hide-details illed
            outline
          ></v-text-field>
          <v-text-field
            v-model="formData.invoiceAddress.street"
            label="Straße und Hausnummer"
            hide-details illed
          ></v-text-field>
          <table class="maxw myTable">
            <tr>
              <td>
                <v-text-field
                  v-model="formData.invoiceAddress.plz"
                  label="PLZ"
                  hide-details illed
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  v-model="formData.invoiceAddress.city"
                  label="Ort"
                  hide-details illed
                ></v-text-field>
              </td>
            </tr>
          </table>
          <!--                    <v-text-field-->
          <!--                            v-model="formData.invoiceAddress.etage"-->
          <!--                            label="Etage (optional)"-->
          <!--                            hide-details illed-->
          <!--                    ></v-text-field>-->
        </div>

        <!--                <div class="indented">-->
        <!--                    <h3>Wohin soll geliefert werden?</h3>-->
        <!--                    <v-text-field-->
        <!--                            v-model="deliveryAddress.company"-->
        <!--                            label="Firma (optional)"-->
        <!--                            hide-details illed-->
        <!--                            outline-->
        <!--                    ></v-text-field>-->
        <!--                    <v-text-field-->
        <!--                            v-model="deliveryAddress.street"-->
        <!--                            label="Straße und Hausnummer"-->
        <!--                            hide-details illed-->
        <!--                    ></v-text-field>-->
        <!--                    <table class="maxw myTable">-->
        <!--                        <tr>-->
        <!--                            <td>-->
        <!--                                <v-text-field-->
        <!--                                        v-model="deliveryAddress.plz"-->
        <!--                                        label="PLZ"-->
        <!--                                        hide-details illed-->
        <!--                                ></v-text-field>-->
        <!--                            </td>-->
        <!--                            <td>-->
        <!--                                <v-text-field-->
        <!--                                        v-model="deliveryAddress.city"-->
        <!--                                        label="Ort"-->
        <!--                                        hide-details illed-->
        <!--                                ></v-text-field>-->
        <!--                            </td>-->
        <!--                        </tr>-->
        <!--                    </table>-->
        <!--                    <v-text-field-->
        <!--                            v-model="deliveryAddress.etage"-->
        <!--                            label="Etage (optional)"-->
        <!--                            hide-details illed-->
        <!--                    ></v-text-field>-->
        <!--                </div>-->


        <div class="indented" v-if="$store.getters.loggedIn === false">
          <h3>Wähle Dein Passwort</h3>
          <v-text-field
            v-model="formData.password"
            label="Passwort (mind. 6 Zeichen)"
            :type="show1 ? 'text' : 'password'"
            @click:append="show1 = !show1"
            :append-icon="show1 ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
            hide-details illed
            required
            @focus="hideToolbar"
            @blur="unhideToolbar"
          ></v-text-field>
        </div>

        <div class="spacer-25"></div>
        <div class="error--text mt-2 mr-4" v-if="displayErrors.length > 0 && initialTry"
             v-html="displayErrors"></div>
        <div class="d-flex flex-wrap align-center justify-sm-start">
          <v-btn large
                 @disabled="process.submitted"
                 @click="doRegister"
                 class="btn-df mr-5 mt-5"
                 rounded
          >Registrieren
          </v-btn>
          <!--                    v-if="displayErrors.length === 0 "-->
          <!--                <div style="margin: 20px 0">-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; ODER -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</div>-->
          <v-btn class="text-none btn-mini mr-5 mt-5" rounded
                 @click.native.passive="gotoSignin">
            Bereits registriert?
          </v-btn>
          <!--                    <div class="pointer mr-5 mt-5">-->
          <!--                        <img style="width: 220px; height: auto" src="../assets/facebooklogin.png"-->
          <!--                             @click.passive="gotoFacebook">-->
          <!--                    </div>-->
        </div>
        <!--            </form>-->
      </v-form>

      <div style="padding: 0 16px;">
        <agb-consent button-name="Kostenlos registrieren"></agb-consent>
      </div>

      <!--            <div class="text-center" style="margin: 25px">-->
      <!--                <v-btn color="primary" class="text-none btn-df" rounded @click.native.passive="gotoSignin">Bereits registriert?</v-btn>-->
      <!--            </div>-->

      <ssl-seal></ssl-seal>

      <sms-dialog :dialog="smsDialog"
                  @close="smsDialog = false"
                  @cancleDialog="cancleDialog"
                  @verifySmsCode="verifySms"></sms-dialog>


      <!--        <qsignal class="hide-md"></qsignal>-->

    </v-container>
  </div>
</template>

<script>
import store from '../store/store'
import * as firebaseUtil from '../firebase/firebaseUtil'
import {ebus} from '../vendor/ebus';
import * as util from "@/vendor/util";
// import {jumpToTop, removeCharacter} from '../vendor/util'
// import * as qconst from '../vendor/qconstants'
import SmsDialog from "../dialogs/SmsDialog";
import AgbConsent from "../components/agbConsent";
import SslSeal from "../components/sslSeal";
import {googlePayMerchantId} from "@/goodpay/goodpayUtil";
import {isMobileOk} from "@/vendor/util";
// import Qsignal from "../components/qsignal";


export default {
  components: {SslSeal, AgbConsent, SmsDialog},
  data() {
    return {
      initialTry: false,
      nextRoute: '',

      displayErrors: '',

      nameRules: [
        v => (!v || this.isNameOk(v)) || 'Ungültiger Name',
      ],

      emailRules: [
        // v => !!v || 'E-Mail is required',
        v => (!v || (/.+@.+[.].+/.test(v))) || 'Ungültige E-Mail',
      ],

      phoneRules: [
        v => !!v || 'Die Mobilnummer wird benötigt',
        // v => /^(?=.*\d)[\d ]+$/.test(v) || 'Dieses Feld darf nur Nummern oder Leerzeichen enthalten',
        v => (v.length >= 10) || 'Die Mobilnummer ist zu kurz'
      ],

      smsDialog: false,


      valid: true,
      showForm: true,
      formData: {
        name: '',
        email: '',
        password: '',
        phone: '',//'+49',
        // techPhone: '', // with +49
        // company: '',
        invoiceAddress: {
          company: '',
          street: '',
          plz: '',
          city: '',
          // etage: '',//optional
        },
      },

      show1: false,

      process: {
        submitted: false,
        userCreated: false,
        nameUpdated: false,
        emailUpdated: false,
        phoneCreated: false,
        // addressCreated: false,
      },

      doSendSms: true,
    }
  },

  watch: {
    // formData: {
    //     handler: function handler(newVal, oldVal) {
    //         this.updateChecks();
    //     },
    //     deep: true,
    // },
    // phone(newValue) {
    // if (!newValue) {
    //     this.formData.phone = '+49';
    //     // } else if (newValue.length > 2 && !newValue.startsWith('+49')) {
    //     //     this.formData.phone = '+49' + newValue;
    // }
    // }
  },

  created() {
    ebus.$on('userSignedIn', () => {
      console.log('Register:: userSignedIn()...');
      if (this.process.submitted) {
        this.process.userCreated = this.isUserCreated();

        this.lazyUpdateEmail();

        // if (!this.process.nameUpdated) {
        if (this.isNameOk()) {
          let name = ('' + this.formData.name).trim();
          firebaseUtil.updateName(name, (ok) => {
            if (ok) {
              console.log('bugIsAccount name updated in register userSignedIn callback !!!! ');
              // this.process.nameUpdated = true;
              console.log('bugIsAccount doSendSms in updateName callback = ' + this.doSendSms);
              if (this.doSendSms || !firebaseUtil.getPhone() || this.getTphone(this.formData.phone) !== firebaseUtil.getPhone()) {
                this.$nextTick(() => {
                  this.startPhoneValidation();
                });
              } else {
                this.checkAccountAndFinish();
              }
            } else {
              this.handleRegistrationError('Fehler beim Speichern', 'Bitte versuche es erneut');
            }
          });
        } else {
          this.process.submitted = false;
          store.commit('showLoading', false);
        }

        this.preselectFields();
        // }

        // } else {
        //     firebaseUtil.logout((ok) => {
        //     });
      }
    });
  },

  // beforeMount() {
  //     if (firebaseUtil.getUser()) {
  //         this.$router.push({name: 'Home'});
  //     }
  // },

  mounted() {
    firebaseUtil.initRecaptcha(() => {
      //captcha solved, now trigger verification
    });
    this.initChecksIv();

    store.commit('hideScroll', true);
    // store.state.hideScoll = true;
    // jumpToTop();
    this.nextRoute = '' + store.state.currentNext;
    console.log('Register:: activated nextRoute = ' + this.nextRoute);
    store.commit('currentNext', '');
    store.commit('loginPostprocessing', false);
    store.commit('duringRegistration', true);

    this.process.userCreated = this.isUserCreated();

    this.doSendSms = true;
    this.preselectFields();

    console.log('enterRegister');
    ebus.$emit('enterRegister');// listener in App

    firebaseUtil.gevent('open_sign_up');

    this.initChecksIv();
    // this.updateChecks();

    // setTimeout(()=>{
    //     this.smsDialog = true;
    // },600);
  },

  destroyed() {
    console.log('????? Register deactivated');
    util.clearEvents([
      'userSignedIn',
    ]);
    store.commit('duringRegistration', false);
    this.clearIv();
    this.unhideToolbar();
    this.finishRegistration();
    if (!firebaseUtil.isAccount()) {
      firebaseUtil.gevent('cancle_sign_up');
    }
  },

  beforeDestroy() {
    store.commit('hideScroll', false);
    // store.state.hideScoll = false;
    store.commit('duringRegistration', false);
    this.finishRegistration();
  },

  methods: {
    isUserCreated() {
      return !!(firebaseUtil.getUser());
    },
    validate() {
      try {
        return this.$refs.form.validate()
      } catch (e) {
        return false;
      }
    },
    clearIv() {
      if (this.ivChecks) {
        util.clearTheInterval(this.ivChecks);
        this.ivChecks = null;
      }
    },
    initChecksIv() {
      this.clearIv();
      this.ivChecks = setInterval(() => {
        if (this.$route.name == 'Registrierung') {
          this.updateChecks();
        }
      }, 2500);
    },

    phoneKeydown(e) {
      //allow backspace, tab and entfernen
      if (e.keyCode === 8 // backspace
        || e.keyCode === 9 //tab
        || e.keyCode === 12 //clear
        || e.keyCode === 16 //shift
        || e.keyCode === 35 //ende
        || e.keyCode === 36 //pos1
        || e.keyCode === 37 //arrow left
        || e.keyCode === 39 //arrow right
        || e.keyCode === 16 //shift
        || e.keyCode === 45 //einfügen
        || e.keyCode === 46 // delete
        || /\d| +/.test(e.key)) {

      } else {
        e.preventDefault();
      }
    },

    updateChecks() {
      this.$nextTick(() => {
        this.displayErrors = this.validateInput();
      });
    },

    checkAccountAndFinish() {
      console.log('checkAccountAndFinish()...');
      let fbUser = firebaseUtil.getUser();
      if (!fbUser) {
        this.handleRegistrationError('Account wurde nicht gefunden');
        return;
      }
      let isAccount = firebaseUtil.isAccount();

      this.process.submitted = false;
      store.commit('showLoading', false);

      if (isAccount) {
        // this.lazyCreateAddress();
        this.$ls.set('hasAccount', 'true');
        // ebus.$emit('accountCreated');
        store.commit('showLoading', false);
        store.commit('duringRegistration', false);
        console.log('??? nextRoute inside checkAccountAndFinish: ' + this.nextRoute);
        if (!this.nextRoute) {
          this.nextRoute = 'Home';
        }
        ebus.$emit('showInfo', {
          title: 'Die Registrierung war erfolgreich 👍',
          // text: 'Nun kannst du mit der Bestellung fortfahren',
          next: '' + this.nextRoute
        });
        ebus.$emit('userSignedIn');
        ebus.$emit('regCompleted');
        firebaseUtil.gevent('sign_up', {method: fbUser.providerData[0].providerId});
        // } else {
        //     this.handleRegistrationError('Bitte gib ein Password zum Schutz deines Accounts ein!',
        //     );
      } else {
        this.handleRegistrationError('Bitte ergänze die fehlenden Felder!', 'Oder versuche es erneut.');
        console.log('bugIsAccount check failed displayName = ' + fbUser.displayName);
        console.log('bugIsAccount check failed email = ' + fbUser.email);
        console.log('bugIsAccount check failed phone = ' + fbUser.phoneNumber);
      }
    },

    lazyUpdateEmail() {
      if (firebaseUtil.getUser()) {
        if (!this.formData.emailUpdated && this.isEmailOk()) {
          let _email = ('' + this.formData.email).trim();
          firebaseUtil.updateUserEmail(_email, (resp) => {
            if (resp.ok) {
              this.formData.emailUpdated = reply.ok;
              console.log('bugIsAccount Email update ok= ' + resp.ok);
            }
          });
        }
      }
    },

    hideToolbar() {
      store.commit('hideToolbar', true);
    },
    unhideToolbar() {
      store.commit('hideToolbar', false);
    },

    lazyUpdateName() {
      console.log('Register:: lazyUpdateName()...');
      if (firebaseUtil.getUser()) {
        if (!this.formData.nameUpdated && this.isNameOk()) {
          let name = ('' + this.formData.name).trim();
          firebaseUtil.updateName(name, (ok) => {
            this.formData.nameUpdated = ok;
            console.log('bugIsAccount Name updated ok + ' + ok);
          });
        }
      }
    },

    isNameOk(v) {
      name = this.formData.name;
      if (v) {
        name = v;
        console.log('isNameOk v=' + v);
      }
      if (name && !(name.length < 4 || name.indexOf(' ') < 2 || name.endsWith(' '))) {
        let nn = this.formData.name.substring(name.indexOf(' ') + 1, name.length);
        // console.log('Nachname: ' + nn);
        // console.log('Nachname length : ' + nn.length);
        let ok = (nn.length > 1);
        // console.log('isNameOk=' + ok);
        return ok;
      }
      // console.log('isNameOk=' + false);
      return false;
    },


    isPasswortOk() {
      return this.formData.password.length >= 6;
    },

    isEmailOk() {
      return this.formData.email && this.formData.email.length > 0 && (/.+@.+[.].+/.test(this.formData.email) === true);
    },

    isPhoneOk() {
      // console.log('this.formData.phone = ' + !!this.formData.phone);
      // console.log('this.formData.phone.length < 10 ' + !!(this.formData.phone.length < 10));
      // console.log('this.$refs.phone.valid ' + !!(this.$refs.phone.valid));
      // console.log('this.$refs.phone.hasError ' + !!(this.$refs.phone.hasError));
      return isMobileOk(this.formData.phone); // { !(!this.formData.phone || this.formData.phone.length < 10 || !this.$refs.phone.valid);
    },

    saveForm() {
      try {
        let _fd = {
          name: this.formData.name,
          phone: this.formData.phone,
          email: this.formData.email,
          // note: this.note,
          // invoiceAddress: util.cloneMe(this.invoiceAddress),
        };
        let fd = util.cloneMe(_fd);
        let ia = this.formData.invoiceAddress;
        if (ia && ia.street && ia.street.length > 0) {
          fd.invoiceAddress = util.cloneMe(this.formData.invoiceAddress);
        }
        // let da = this.formData.deliveryAddress;
        // if (da && da.street && da.street.length > 0) {
        //     fd.deliveryAddress = util.cloneMe(da);
        // }
        util.sanitizeProps(fd);
        util.removeEmptyProps(fd);
        if (fd.name || fd.email) {
          this.$ls.set('formData', fd);
          // this.$ls.set('inhouseformData', fd);
          // this.$ls.set('formDataDelivery', fd);
        }

        let user = {
          name: fd.name,
          email: fd.email,
          phone: fd.phone,
        };
        util.removeEmptyProps(user);
        store.commit('user', user);

      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('error in saveForm: ' + e.message));
      }
    },

    preselectFields() {
      let fbUser = firebaseUtil.getUser();
      if (fbUser) {
        if (fbUser.displayName) {
          this.formData.name = fbUser.displayName;
        }
        if (fbUser.email) {
          this.formData.email = fbUser.email;
        }
        if (fbUser.phoneNumber) {
          let p = fbUser.phoneNumber;
          this.formData.phone = '0' + p.substring(3, p.length);
        }
      }

      let fd = this.$ls.get('formData') || {};
      if (this.formData.name.length === 0) {
        this.formData.name = fd.name;
        this.formData.email = fd.email;
        if (fd.phone) {
          this.formData.phone = fd.phone;
        }
      }
      if (fd.invoiceAddress) {
        let ia = fd.invoiceAddress;
        if (ia.company) {
          this.formData.invoiceAddress.company = ia.company
        }
        if (ia.street) {
          this.formData.invoiceAddress.street = ia.street
        }
        if (ia.plz) {
          this.formData.invoiceAddress.plz = ia.plz
        }
        if (ia.city) {
          this.formData.invoiceAddress.city = ia.city
        }
        // if (ia.etage) {
        //     this.formData.invoiceAddress.etage = ia.etage
        // }
      }
    },

    gotoSignin() {
      // let validationErros = this.validateInput();
      // alert('validationErros : ' + validationErros);
      this.$router.push({name: 'Anmelden'});
    },

    gotoFacebook() {
      this.$ls.set('registerFB', 'true');
      this.$router.push({name: 'Anmelden'});
    },

    finishRegistration() {
      console.log('??? finish registration...');
      setTimeout(() => {
        this.nextRoute = ''; //reset nextRoute
      }, 2000);
      let s = '' + this.formData.invoiceAddress.street;
      if (s.length > 0) {
        ebus.$emit('localStoreIA', util.cloneMe(this.formData.invoiceAddress));
        // this.$ls.set('company', c);
      }
      // let user = firebaseUtil.getUser();
      // if (user && user.phoneNumber && user.phoneNumber.length > 4) {
      //     //registration was successful
      //     // store.commit('currentNext', '');
      //     this.nextRoute = ''; //reset nextRoute
      // } else {
      //     if (user) {
      //         firebaseUtil.logout((ok) => {
      //         });
      //     }
      // }
    },

    // startFacebookLogin(){
    //     let provider = new firebase.auth.FacebookAuthProvider();
    //
    // },

    getTphone(phone) {
      let tPhone = '' + phone;
      if (tPhone.startsWith('00')) {
        tPhone = '+' + tPhone.substring(2, tPhone.length);
        //results in +490176
      } else if (!tPhone.startsWith('+49')) {
        tPhone = '+49' + tPhone;
      }
      // if (!this.formData.phone.startsWith('+')) {
      //     this.formData.phone = '+' + this.formData.phone;
      // }

      //remove all spaces
      tPhone = tPhone.replace(/\s/g, '');
      if (tPhone.startsWith('+') && tPhone.length >= 4 && tPhone.charAt(3) === '0') {
        //remove the zero after the country
        tPhone = util.removeCharacter(tPhone, 3);
      }
      return tPhone;
    },

    startPhoneValidation() {
      // let fbUser = firebaseUtil.getUser();
      // if (fbUser && fbUser.phoneNumber && fbUser.phoneNumber.length > 6) {
      //     //phone number already registered
      //     this.doSendSms = false;
      //     console.log('bugIsAccount phoneNumber in startPhoneValidation is already verified');
      //     this.checkAccountAndFinish();
      //     return;
      // }

      //Now add the mobile number
      let tPhone = this.getTphone(this.formData.phone);

      console.log('??? tPhone = ' + tPhone);
      this.formData.phone = tPhone;

      firebaseUtil.sendSms(tPhone, (smsSent) => {
        console.log('??? SMS sent = ' + smsSent);
        if (smsSent) {
          this.smsDialog = true;
          store.commit('showLoading', false);
        } else {
          this.handleRegistrationError('Deine Mobilnummer ist ungültig!', 'Bitte überprüfe deine Mobilnummer');
        }
      });
    },

    cancleDialog() {
      store.commit('showLoading', false);
    },

    // notifyError(text, err) {
    //     this.$notify({
    //         type: 'error',
    //         title: text,
    //         text: err || ''
    //     });
    // },

    handleRegistrationError(errorMsg, errText) {
      this.$nextTick(() => {
        this.process.submitted = false;
        store.commit('showLoading', false);
        if (errText) {
          ebus.$emit('showInfo', {title: errorMsg, text: errText});
        } else {
          ebus.$emit('showInfo', {title: errorMsg});
        }
      });
    },

    validateInput() {
      // console.log('validateInput()...');
      let errors = '';
      try {
        if (!this.isNameOk()) {
          errors += 'Bitte Vor- und Nachname eingeben<br>';
          return errors;
        } else {
          let nn = this.formData.name.substring(this.formData.name.indexOf(' ') + 1, this.formData.name.length);
          if (nn.length < 2) {
            errors += 'Bitte Vor- und Nachname eingeben<br>';
            return errors;
          }
        }
        if (!this.isEmailOk()) {
          errors += 'Die E-Mail Addresse ist ungültig<br>';
          return errors;
        } else {
          // console.log('email is ok');
        }

        try {
          // //auto prefix country
          // if (!this.formData.phone.startsWith('+')) {
          //     this.formData.phone = '+49' + this.formData.phone;
          // }
          if (!this.isPhoneOk()) {
            return 'Die eingegebene Mobilnummer ist ungültig';
          } else {
            // console.log('phone is ok');
          }
        } catch (e) {
          console.log('FIXME phone error: ' + e.message);
        }

        if (store.getters.loggedIn === false && !this.isPasswortOk()) {
          errors += 'Bitte wähle ein Passwort mit mindestens 6 Zeichen';
          return errors;
        } else {
          // console.log('password is ok');
        }

      } catch (e) {
        console.log('Error in updateChecks: ' + e.message);
      }
      return errors;
    },

    doRegister() {
      console.log('doRegister()...');

      if (this.displayErrors.length > 0 || !this.validate()) {
        this.initialTry = true;
        return;
      }

      store.commit('showLoading', true);

      this.saveForm();

      //validate input
      let validationErros = this.validateInput();
      if (validationErros.length > 0) {
        store.commit('showLoading', false);
        ebus.$emit('showInfo', {title: validationErros, text: 'Bitte korrigiere deine Eingabe'});
        return;
      }

      this.process.submitted = true;//hides the submit button

      this.process.userCreated = this.isUserCreated();

      console.log('bugIsAccount doRegister user already loggedIn/created = ' + this.process.userCreated);
      if (!this.process.userCreated) {
        let _email = ('' + this.formData.email).trim();
        let _password = '' + this.formData.password;

        console.log('createUserWithEmailAndPassword()...');

        //triggers userSignedIn event
        //https://firebase.google.com/docs/reference/js/firebase.auth.Auth.html#createuserwithemailandpassword
        firebaseUtil.auth().createUserWithEmailAndPassword(_email, _password)
          .then((userCredential) => {
            // Signed in
            // const user = userCredential.user;
            // ...
            console.log('createUserWithEmailAndPassword then  Signed in');
            console.log('createUserWithEmailAndPassword then  isAccount = ' + !!firebaseUtil.isAccount());
            if (firebaseUtil.isAccount()) {
              this.checkAccountAndFinish();
            }
          })
          .catch((error) => {

            console.log('createUserWithEmailAndPassword catched error...');

            // Handle Errors here.
            let errorCode = error.code;
            let errorMessage = error.message;

            console.log('bugIsAccount errorCode=' + errorCode);
            console.log('bugIsAccount errorMessage=' + errorMessage);

            if (errorCode === 'auth/email-already-in-use') {
              console.log('??? email already exists which is OK. Now try to login...');

              //triggers userSignedIn event
              console.log('signInWithEmailAndPassword()...');
              firebaseUtil.auth().signInWithEmailAndPassword(_email, _password)
                .catch((signinErr) => {
                  this.handleRegistrationError(signinErr.message);
                });
              return;
            }

            //Another error is auth/user-token-expired
            // The password is invalid or the user does not have a password.

            // store.commit('showLoading', false);

            // if (errorCode === 'auth/weak-password') {
            //     alert('The password is too weak.');
            // } else {
            //     alert(errorMessage);
            // }
            ebus.$emit('showInfo', {title: errorMessage});
          });
      } else {
        //we don't need to create the user again. Let's continue the registration
        this.lazyUpdateName();

        setTimeout(() => {
          this.lazyUpdateEmail();//may lead to userSignedOut; see https://firebase.google.com/docs/auth/admin/manage-sessions
        }, 1400);

        setTimeout(() => {
          console.log('bugIsAccount call doRegister isPhoneOk()');
          // if (firebaseUtil.isPhoneOk()) {
          //     console.log('bugIsAccount call doRegister checkAccountAndFinish()');
          //     this.checkAccountAndFinish();
          // } else {
          console.log('bugIsAccount call doRegister startPhoneValidation()');
          this.startPhoneValidation();
          // }
        }, 2500);
      }
    },


    verifySms(smsCode) {
      console.log('??? try to verifySmsCode ' + smsCode);
      let phoneCredential = firebaseUtil.verifySmsCode(smsCode);

      console.log('bugIsAccount phoneCredential: ' + phoneCredential);

      //update user
      firebaseUtil.updatePhone(phoneCredential).then((updatedUser) => {
        console.log('bugIsAccount updatePhoneNumber inside verifySms succeeded');
        this.doSendSms = false; //prevent the SMS to be sent twice
        this.process.phoneCreated = true;

        // firebaseUtil.singinWithPhoneCredential(phoneCredential);

        this.checkAccountAndFinish();
        // if (this.nextRoute.length > 0) {
        //     let next = '' + this.nextRoute;
        //     this.$router.push({name: next});
        // }
      }, (verifyErr) => {
        console.log('bugIsAccount phone verifyError: ' + JSON.stringify(verifyErr));
        let msg;
        if (verifyErr.code === 'auth/invalid-verification-code') {
          msg = 'Der eingegebene Bestätigungscode ist ungültig';
        } else if (verifyErr.code === 'auth/credential-already-in-use') {
          msg = 'Die Mobilnummer wird bereits von einem anderen Account verwendet';
        } else {
          msg = 'Fehler bei der Überprüfung der Mobilnummer';
        }
        //https://firebase.google.com/docs/reference/node/firebase.User.html#updatephonenumber
        this.handleRegistrationError(msg);
      });
    },

    // lazyCreateAddress() {
    //     if (!this.process.addressCreated) {
    //         this.deliveryAddress.company.trim();
    //         this.deliveryAddress.street.trim();
    //         this.deliveryAddress.plz.trim();
    //         this.deliveryAddress.city.trim();
    //         this.deliveryAddress.etage.trim();
    //         this.$ls.set('deliveryAddress', JSON.stringify(this.deliveryAddress));
    //
    //         ebus.$emit('updateRelevantArea');
    //
    //         store.commit('showLoading', false);
    //         this.process.addressCreated = true;
    //     }
    // }


  }
}
</script>
<style lang="scss" scoped>
@import '../styles/base';
/*@import '../styles/sharedStyles';*/

.page {
  /*To debug textfield background*/
  //background-color: $color-secondary;

  select {
    -moz-appearance: menulist !important;
    -webkit-appearance: menulist !important;
  }
}

.page ::v-deep .v-stepper {
  box-shadow: none;
  background: transparent;
}

.page ::v-deep .v-stepper__step__step {
  background-color: $color-primary !important;
  /*background-color: transparent !important;*/
  border: 1px solid $color-primary !important;
  color: white !important;
}

.page ::v-deep .v-text-field .v-input__slot {
  overflow: hidden;
  background-color: white;
  border: 1px solid #666;
  border-radius: $box-border-radius;
  /*min-height: 60px;*/
  padding: 6px 0 6px 10px;
}


.page ::v-deep .v-input {
  font-size: $fontSize;
}

.page ::v-deep .v-input__append-inner {
  margin-top: 4px;
}

.page ::v-deep .v-text-field .v-label {
  top: 20px;
}

//.page ::v-deep input {
//  padding: 14px 0 0 0;
//}


.page .nolabel ::v-deep input {
  padding: 0;
  margin: 7px 4px 7px 0;
}


.page ::v-deep .v-input__slot:before {
  border: none;
}

.page ::v-deep .v-input__append-inner {
  margin-top: 6px;
}

.page ::v-deep .v-select__selections input {
  padding: 0;
  margin: 7px 4px 7px 0;
}

.indented {
  margin-top: 25px;
}


.myTable {
  tr {
    td:first-child {
      width: 115px;
    }

    td:last-child {
      padding-left: 8px;
    }
  }
}


</style>
